<template>
  <div
    id="home"
    class="homepage"
    :class="[{ useMock: useMock }, { onExpand: bannerExpand }]"
  >
    <SearchInput v-if="useMock" isHomepage />
    <div v-if="ready">
      <div v-for="(block, i) in curationAll.sequence" :key="'block' + i">
        <div v-if="block === 'regularBannerBlock'" class="top-section">
          <AdsCarousel
            :banners="banners"
            @onExpand="bannerExpand = !bannerExpand"
          />
        </div>
        <div v-else-if="block === 'selfBuildCategoryBlock' && selfBuildCatData.length" class="nav-icon-links--container">
          <SelfBuildCategory :icons="selfBuildCatData" />
        </div>
        <div v-else-if="block === 'channelBlock' && icons.length" class="nav-icon-links--container">
          <NavIconLinks :icons="icons" />
        </div>
        <div v-else-if="block === 'activeImageBannerBlock' && activeBanners.length > 1" class="active-banners">
          <div
            v-for="(banner, index) in activeBanners"
            :key="'ab' + index"
            class="banner"
            @click="toCuration(banner)"
          >
            <img onerror="this.classList.add('error-img')" :src="banner.img" />
            <img class="error-holder" src="@/assets/img/placholder_1200.svg" />
          </div>
        </div>
        <RowList
          v-else-if="block === 'weeklyHotBlock'"
          :products="products"
          title="本週熱賣"
          curationGuid="hotSale"
          gaEvent="004"
        />
        <div v-else-if="block === 'curationBlock'" class="curation-section">
          <div
            class="curation-container"
            v-for="(curation, i) in curationAll.curationBlock"
            :key="i"
          >
            <CurationC
              v-if="curation.type === 7"
              :title="curation.title"
              :curationGuid="curation.content.curationGuid"
              :products="curation.content.products.slice(0, 6)"
            />
            <RowList
              v-else-if="curation.type === 13"
              :title="curation.title"
              :curationGuid="curation.content.curationGuid"
              :products="curation.content.products.slice(0, 10)"
              gaEvent="007"
            />
            <CurationLayout3
              v-else
              :layout="curation.type"
              :title="curation.title"
              :curationGuid="curation.content.curationGuid"
              :products="curation.content.products"
            />
          </div>
        </div>
        <div
          v-else-if="block === 'brandBlock'"
          class="brand-recommend"
          v-for="(brands, index) in brandBlock"
          :key="'brand' + index"
        >
          <SectionTitle :title="brands.title" :more-link="'homepage-brandlist'" />
          <div class="button-swiper">
            <IconLinkSlider :iconLinks="brands.content" />
          </div>
        </div>
        <div
          v-else-if="block === 'selectedProductBlock' && selectProducts.length && curationAll.selectedProductBlock"
          class="chosen-product-container"
        >
          <SectionTitle :title="'精選商品'" hide-more />
          <FlowList
            productType
            :inTheEnd="selectInTheEnd"
            :totalCount="selectTotalCount"
            :products="selectProducts"
            :loading="selectLoading"
            @goToSeeMore="getSelectDeals(10)"
          />
        </div>
        <div
          v-else-if="block === 'allProductBlock' && allProducts.length && curationAll.allProductBlock"
          class="chosen-product-container"
        >
          <SectionTitle :title="'全部商品'" hide-more />
          <FlowList
            :inTheEnd="inTheEnd"
            :totalCount="totalCount"
            :products="allProducts"
            :loading="loading"
            @goToSeeMore="getAllDeals(10)"
          />
        </div>
      </div>
    </div>

    <Spinner v-else bgc="#f6f6f6" />
    <AboutBlock />
  </div>
</template>

<script>
import AdsCarousel from '@/components/homepage/AdsCarousel.vue'
import NavIconLinks from '@/components/homepage/NavIconLinks.vue'
import CurationLayout3 from '@/components/homepage/CurationLayout3.vue'
import CurationC from '@/components/homepage/CurationC.vue'
import AboutBlock from '@/components/shared/AboutBlock.vue'
import Spinner from '@/components/shared/Spinner.vue'
import SearchInput from '@/components/search/SearchInput.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import IconLinkSlider from '@/components/IconLinkSlider.vue'
import FlowList from '@/components/layout/flowList.vue'
import RowList from '@/components/layout/rowList.vue'
import SelfBuildCategory from '@/components/homepage/SelfBuildCategory.vue'
import moment from 'moment'

export default {
  name: 'homepage',
  components: {
    AdsCarousel,
    NavIconLinks,
    CurationLayout3,
    CurationC,
    AboutBlock,
    Spinner,
    SearchInput,
    SectionTitle,
    IconLinkSlider,
    FlowList,
    RowList,
    SelfBuildCategory,
  },
  data: () => ({
    banners: [],
    activeBanners: [],
    icons: [],
    products: [],
    curationAll: [],
    allProducts: [],
    selectProducts: [],
    brandBlock: [],
    inTheEnd: true,
    selectInTheEnd: true,
    totalCount: 0,
    selectTotalCount: 0,
    startIndex: 0,
    selectStartIndex: 0,
    ready: false,
    loading: false,
    selectLoading: false,
    bannerExpand: false,
    maintainStart: '',
    maintainEnd: '',
    maintainType: '',
    selfBuildCatData: [],
  }),
  methods: {
    isMaintenance() {
      const startTime = moment(this.maintainStart, 'YYYY-MM-DD HH:mm:ss')
      const endTime = moment(this.maintainEnd, 'YYYY-MM-DD HH:mm:ss')
      return moment().isBetween(startTime, endTime) && this.maintainType == 1
    },
    goMaintenance() {
      this.$router.replace('/Maintenance')
    },
    async getMaintenanceInfo() {
      try {
        const res = await api.getMaintenanceInfo()
        if (res.data) {
          localStorage.setItem('maintenanceInfo', JSON.stringify(res.data))
          this.maintainStart = res.data.startTime
          this.maintainEnd = res.data.endTime
          this.maintainType = res.data.maintenanceType
          this.goMaintenance()
          this.isMaintenance() ? this.goMaintenance() : ''
        }
        this.loading = false
      } catch (err) {
        console.log('getMaintenance error:', err.message)
      }
    },
    loadData() {
      api
        .getHomepage(this.$route.query.preview)
        .then(res => {
          this.curationAll = res.data
          if(!this.curationAll.sequence || !this.curationAll.sequence.length) {
            console.log('no sequence, use default')
            this.curationAll.sequence = [
              'regularBannerBlock', 'selfBuildCategoryBlock', 'channelBlock', 'activeImageBannerBlock', 'weeklyHotBlock', 'curationBlock', 'brandBlock', 'selectedProductBlock', 'allProductBlock'
            ]
          }
          this.selfBuildCatData = this.curationAll.selfBuildCategoryBlock
          this.banners = this.curationAll.regularBannerBlock
          localStorage.setItem('banners', JSON.stringify(this.banners))
          this.icons = this.curationAll.channelBlock
          this.icons.forEach((icon, index) => {
            icon.categoryNumber = index + 1
          })
          this.products = this.curationAll.weeklyHotBlock
          if (res.data.brandBlock.length) {
            this.brandBlock.push(res.data.brandBlock[0])
          }
          this.activeBanners = this.curationAll.activeImageBannerBlock.slice(
            0,
            2
          )
          localStorage.setItem('brandList', JSON.stringify(res.data.brandBlock))
          this.ready = true
          if (this.curationAll.selectedProductBlock) this.getSelectDeals(0)
          if (this.curationAll.allProductBlock) this.getAllDeals(0)
          setTimeout(() => {
            this.$bus.$emit(
              'updateContentHeight',
              document.getElementById('home').offsetHeight
            )
          }, 300)
        })
        .catch(err => {
          console.log(err)
        })
    },
    getAllDeals(index) {
      this.loading = true
      this.startIndex += index
      api
        .getAllDealsForHomePage(this.startIndex)
        .then(res => {
          const list = res.data.dealList.filter(el => el)
          this.allProducts.push(...list)
          this.inTheEnd = res.data.inTheEnd
          this.totalCount = res.data.totalCount
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.loading = false
        })
    },
    getSelectDeals(index) {
      this.selectLoading = true
      this.selectStartIndex += index
      if (index) {
        gtag('event', 'click', {
          event_id: '012',
          location: '首頁',
          event_category: '看更多',
          event_label: '精選商品--看更多',
          value: 12,
        })
      }
      api
        .getSelectedDealsForHomePage(this.selectStartIndex)
        .then(res => {
          const list = res.data.dealList.filter(el => el)
          this.selectProducts.push(...list)
          this.selectInTheEnd = res.data.inTheEnd
          this.selectTotalCount = res.data.totalCount
          this.selectLoading = false
        })
        .catch(err => {
          console.log(err)
          this.selectLoading = false
        })
    },
    toCuration(banner) {
      gtag('event', 'click', {
        event_id: '001',
        location: '首頁',
        event_category: '活動banner',
        event_label: banner.title,
        value: 1,
      })
      this.$router.push({ name: 'curation', params: { id: banner.link } })
    },
  },
  mounted() {
    const overlay = document.querySelector('.nav-overlay')
    if (overlay != null) {
      overlay.remove()
    }
    // this.brandBlock.push({
    //   title: '熱門品牌',
    //   content: [
    //     ...Array(10).fill({
    //       title: '王品集團',
    //       imagePath:
    //         'https://iceman.17life.com/media/A0-10-465/a9977776-83e9-4861-8062-784b6f902907.jpg?ts=B2AECCD9',
    //       curationGuid: '5fe2e71b-c8b5-4260-8f1e-32e8a5c08af4',
    //     }),
    //   ],
    // })
    this.getMaintenanceInfo()
    this.loadData()
  },
  computed: {
    useMock() {
      return process.env.VUE_APP_USE_DEV == 'true'
    },
  },
}
</script>

<style lang="scss" scoped>
body {
  margin: 0px;
}
.homepage {
  // padding-top: 10px;
  &.onExpand {
    max-height: 100vh;
    overflow: hidden;
  }
  &.useMock {
    padding-top: 75px;
  }
  .top-section {
    padding: 8px 4.3%;
  }
  .nav-icon-links--container {
    padding: 0px 4.3%;
  }

  .active-banners {
    padding: 8px 4.3%;
    display: flex;
    justify-content: space-between;
    .banner {
      font-size: 0;
      width: 48.7%;
      border-radius: 8px;
      overflow: hidden;
      img {
        width: 100%;
        &.error-img {
          display: none;
          & + .error-holder {
            display: block;
          }
        }
      }
      .error-holder {
        display: none;
      }
    }
  }

  .curation-container {
    border-top: 10px solid #f1f2f2;
    &:last-child {
      border-bottom: 10px solid #f1f2f2;
    }
  }
  .brand-recommend {
    padding: 24px 4.3%;
    position: relative;
    z-index: 0;
    .swiper-container {
      overflow: hidden;
      font-size: 0;
      min-height: 150px;
    }
  }

  .chosen-product-container {
    padding: 24px 4.3%;
  }
}
</style>
